import { mergeToNewObject } from '../../../util/helpers'
import { MENU_ACTIONS } from '../../../constants/actions'

export const menuReducer = (state = INITIAL_STATE, { type }) => {
  switch (type) {
    case MENU_ACTIONS.ON_MENU_MOUSE_ENTER:
      return mergeToNewObject(state, { hovering: true })

    case MENU_ACTIONS.ON_MENU_MOUSE_LEAVE:
      return mergeToNewObject(state, { hovering: false })

    case MENU_ACTIONS.ON_MENU_CLICK:
      return mergeToNewObject(state, { open: !state.open })

    case MENU_ACTIONS.ON_CLOSE_MENU:
      return mergeToNewObject(state, { open: false })

    default:
      return state
  }
}

const INITIAL_STATE = {
  open: false,
  hovering: false
}



// WEBPACK FOOTER //
// ./src/store/reducers/menu/index.js